// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-medium-viewport":"(min-width: 960px)","left-nav":"left-nav_left-nav__tj2rk","left-nav-toggle":"left-nav_left-nav-toggle__M_yBT","collapsed":"left-nav_collapsed__qwCmx"};